<template>
  <div class="px-20 py-20 border-box">
    <el-card shadow="never" header="提醒设置">
      <el-form :model="form" label-width="140px" style="max-width:560px">
        <el-form-item label="提前提醒天数">
          <el-input-number v-model="form.advanceDays" :min="1" :max="365" />
          <span class="ml-10 c-tip">合同签订到期前 N 天进行提醒</span>
        </el-form-item>
        <el-form-item label="浏览器推送">
          <el-switch v-model="browserPushFlag" />
        </el-form-item>
        <el-form-item label="通知渠道">
          <el-checkbox-group v-model="channels">
            <el-checkbox label="system">站内消息</el-checkbox>
            <el-checkbox label="email">邮件</el-checkbox>
            <el-checkbox label="sms">短信</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="enabledFlag" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getRemindSettingApi, saveRemindSettingApi } from '@/api/laborContract/index'

export default {
  name: 'LaborSettings',
  data() {
    return {
      form: { advanceDays: 30, browserPush: 1, notifyChannel: 'system', enabled: 1 },
      channels: ['system']
    }
  },
  computed: {
    browserPushFlag: {
      get() { return this.form.browserPush === 1 },
      set(v) { this.form.browserPush = v ? 1 : 0 }
    },
    enabledFlag: {
      get() { return this.form.enabled === 1 },
      set(v) { this.form.enabled = v ? 1 : 0 }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      getRemindSettingApi({}).then(res => {
        if (res.code == 200) {
          const d = res.data || {}
          this.form.advanceDays = d.advanceDays || 30
          this.form.browserPush = d.browserPush || 0
          this.form.notifyChannel = d.notifyChannel || 'system'
          this.form.enabled = d.enabled == null ? 1 : d.enabled
          this.channels = (this.form.notifyChannel || '').split(',')
        }
      })
    },
    save() {
      this.form.notifyChannel = this.channels.join(',')
      saveRemindSettingApi(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    }
  }
}
</script>
